import { Directive, ElementRef, HostListener, Input, OnInit } from '@angular/core';
import * as $ from 'jquery';
import { fromEvent } from 'rxjs';

@Directive({
  selector: '[appTwoDigitDecimaNumber]'
})
export class TwoDigitDecimaNumberDirective implements OnInit{
  prevValue = '';
  clicks = fromEvent(document, 'click');
  @Input() callingFrom : string
  // Allow decimal numbers and negative values
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,2}$/g);
  // Allow key codes for special events. Reflect :
  // Backspace, tab, end, home
  private specialKeys: Array<string> = ['Backspace', 'End', 'Home', 'ArrowLeft', 'ArrowRight', 'Del', 'Delete'];

  constructor(private el: ElementRef) {}
  ngOnInit(): void {
    if(this.callingFrom === "deposit"){
      // allowing decimal at the time of withdraw but not allowing at the time of deposit.
      this.regex = new RegExp(/^(\d+(\.\d{0,2})?)?$/g);
    }else{
      // now not allowing decimal as brite is failing to initiate payment for float.
      this.regex = new RegExp(/^\d*\d{0,2}$/g)
    }
  }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    this.prevValue =this.el.nativeElement.innerText
    let eventKeyValue = event.key.toString();
    eventKeyValue = eventKeyValue ? eventKeyValue.trim() : "";
    /*Added this code for vertual keyboard because mobile's vertual keyboard is not throwing event properly
    *Handle "Unidentified" key (virtual keyboard behavior)
    *This below code will redirect to input event written below which will handle vertual keyboard event properly.
     */ 
    if (event.key === 'Unidentified' || event.keyCode === 229) {
      event.preventDefault();
      return; // Prevent further action
    }
    if ((!this.el.nativeElement.innerText || !parseFloat(this.el.nativeElement.innerText)) && (event.keyCode == 48 || event.keyCode == 190)  || !eventKeyValue) {
      event.preventDefault();
    }
    if (this.specialKeys.indexOf(eventKeyValue) !== -1) {
      return;
    }
    let current: string = this.el.nativeElement.innerText;
    current = current.trim()
    const position = this.el.nativeElement.innerText.length;
    let next: string = [current.slice(0, position), eventKeyValue == 'Decimal' ? '.' : eventKeyValue, current.slice(position)].join('');
    next = next.trim()
    if (next && !String(next).match(this.regex)) {
      event.preventDefault();
    }
  }

    // Handle input event (after the key is processed, used as fallback)
    @HostListener('input', ['$event'])
    onInput(event: InputEvent) {
      const currentValue = this.el.nativeElement.innerText.trim();
      const data = event.data?.trim();
      // Prevent spaces from being inserted
      if ((!currentValue.match(this.regex) || data.length === 0) && this.callingFrom === "withdraw") {
        // If invalid input, revert to previous value
        this.el.nativeElement.innerText = this.prevValue;
      }
    }
}

// 30-39